import { message } from "antd";

const ENDPOINT = 'https://webapi-cashslip.labflow.it'

function saveInStorage(key, element){
    localStorage.setItem(key,element);
}

export function messageGeneral(){
    const [messageApi, contextHolder] = message.useMessage();
    return [contextHolder, messageApi.info];
}

export function checkLogIn () {
    return JSON.parse( localStorage.getItem('enterprise') );
}

export function getEnterpriseInfo(){
   return JSON.parse( localStorage.getItem('enterprise') )
}


export async function addEnterprise( businessName, name, email, password, role ) {
    try{
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    
    const options = {
        'headers' : headers,
        'method'  : 'POST',
        'body'    : JSON.stringify(
            {
                "businessName": businessName,
                "name": name,
                "email":email,
                "password": password,
                "role": role
            }
        )
    }
    

    const resp = await fetch(ENDPOINT+'/api/v1/company/createCompany', options);
    if( resp.status == 201 ){
        const json = await resp.json();
        if( json.success ){
            return true;
        }
    };
    return false;

    }catch(err){
        console.log(err);
        return false;
    }
    
}

export async function logInFunction( email, password ) {
    try{
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    
    const options = {
        'headers' : headers,
        'method'  : 'POST',
        'body'    : JSON.stringify(
            {
                "email":email,
                "password": password,
            }
        )
    }
    

    const resp = await fetch(ENDPOINT+'/api/v1/company/login', options);
    if( resp.status == 201 ){
        const json = await resp.json();
        if( json.success ){
            saveInStorage('enterprise', JSON.stringify(json.data))
            return true;
        }
    };
    return false;

    }catch(err){
        console.log(err);
        return false;
    }
    
} 


////////////////////////////CASUAL////////////////////////////////////////////////

export async function getCausal() {
    try{
    const resp = await fetch(ENDPOINT+'/api/v1/causal/list?tokenCompany='+getEnterpriseInfo().tokenCompany);
    if( resp.status == 200 ){
        const json = await resp.json();
        if( json.success ){
            return json.data;
        }
    };
    return [];

    }catch(err){
        return [];
    }
}

export async function addCausal( name, type, tokenEntity, dataDoc, fornitore, imponibile, nota, numeroDocumento, totaleiva ) {
    try{
        const options ={
            'headers' : { 'Content-Type' : 'application/json'},
            'method'  : 'POST',
            'body'    : JSON.stringify(
                {
                    "token"       : tokenEntity,
                    "name"        : name,
                    "movementType": type,
                    "tokenUser"   : getEnterpriseInfo().tokenUser,
                    "tokenCompany": getEnterpriseInfo().tokenCompany,
                    "mandatoryTitle" : nota == true ? 1 : 0,
                    "mandatoryDocumentDate": dataDoc == true ? 1 : 0,
                    "mandatoryBillNumber": numeroDocumento == true ? 1 : 0,
                    "mandatoryAmount": imponibile == true ? 1 : 0,
                    "mandatoryAmountTaxable": totaleiva == true ? 1 : 0,
                    "mandatoryVatRate": 1,
                    "mandatoryCustomer": fornitore == true ? 1 : 0,
                    "mandatorySupplier": fornitore == true ? 1 : 0,
                    "mandatoryPointOfSale": 1,
                    "mandatoryUser": 1
                }
            )
        }

        const resp = await fetch(ENDPOINT+'/api/v1/causal/save', options);
        if( resp.status == 201 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}

export async function removeCausal( tokenCausal ) {
    try{
        const resp = await fetch( ENDPOINT+'/api/v1/causal/remove?tokenCompany='+getEnterpriseInfo().tokenCompany+'&tokenCausal=' + tokenCausal, { 'method':'DELETE' });
        if( resp.status == 200 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}


////////////////////////////Fornitori////////////////////////////////////////////////
export async function getSuppliers() {
    try{
    const resp = await fetch(ENDPOINT+'/api/v1/supplier/list?tokenCompany='+getEnterpriseInfo().tokenCompany);
    if( resp.status == 200 ){
        const json = await resp.json();
        if( json.success ){
            return json.data;
        }
    };
    return [];

    }catch(err){
        return [];
    }
}

export async function addSupplierFunction( businessName, vatNumber, fiscalCode, tokenEntity ) {
    try{
        const options ={
            'headers' : { 'Content-Type' : 'application/json'},
            'method'  : 'POST',
            'body'    : JSON.stringify(
                {
                    "token"       : tokenEntity,
                    "businessName": businessName,
                    "fullname"    : businessName,
                    "vatNumber"   : vatNumber,
                    "fiscalCode"  : fiscalCode,
                    "tokenUser"   : getEnterpriseInfo().tokenUser,
                    "tokenCompany": getEnterpriseInfo().tokenCompany
                }
            )
        }

        const resp = await fetch(ENDPOINT+'/api/v1/supplier/save', options);
        if( resp.status == 201 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}

export async function removeSupplier( tokenSupplier ) {
    try{
        const resp = await fetch( ENDPOINT+'/api/v1/supplier/remove?tokenCompany='+getEnterpriseInfo().tokenCompany+'&tokenSupplier=' + tokenSupplier, { 'method':'DELETE' });
        if( resp.status == 200 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}

////////////////////////////Operatori////////////////////////////////////////////////
export async function getOperators() {
    try{
    const resp = await fetch(ENDPOINT+'/api/v1/user/list?tokenCompany='+getEnterpriseInfo().tokenCompany);
    if( resp.status == 200 ){
        const json = await resp.json();
        if( json.success ){
            return json.data;
        }
    };
    return [];

    }catch(err){
        return [];
    }
}

export async function addOperatorFunction( name, email, password, tokenPointOfSale, tokenEntity ) {
    try{
        const options ={
            'headers' : { 'Content-Type' : 'application/json'},
            'method'  : 'POST',
            'body'    : JSON.stringify(
                {
                    "token"       : tokenEntity,
                    "name"        : name,
                    "email"       : email,
                    "role"        : 'operator',
                    'password'    : password,
                    "tokenUser"   : getEnterpriseInfo().tokenUser,
                    "tokenCompany": getEnterpriseInfo().tokenCompany,
                    "tokenPointOfSale": tokenPointOfSale

                }
            )
        }

        const resp = await fetch(ENDPOINT+'/api/v1/user/save', options);
        const json = await resp.json();
        if( resp.status == 201 ){
            if( json.success ){
                return {success: true };
            }
        };
        return {success: false, message: json };

    }catch(err){
        return {success: false, message: err };;
    }
}

export async function removeOperator( tokenOperator ) {
    try{
        const resp = await fetch( ENDPOINT+'/api/v1/user/remove?tokenCompany='+getEnterpriseInfo().tokenCompany+'&tokenUser=' + tokenOperator, { 'method':'DELETE' });
        if( resp.status == 200 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}

////////////////////////////STORE////////////////////////////////////////////////
export async function getStore( company ) {
    try{
    const resp = await fetch(ENDPOINT+'/api/v1/pointOfSale/list?tokenCompany='+getEnterpriseInfo().tokenCompany + (company ? '&filterCompany=1' : '&filterCompany=0'));
    if( resp.status == 200 ){
        const json = await resp.json();
        if( json.success ){
            return json.data;
        }
    };
    return [];

    }catch(err){
        return [];
    }
}

export async function addStoreFunction( name, /* city, zipCode, address,  */tokenEntity , company) {
    try{
        let options ={
            'headers' : { 'Content-Type' : 'application/json'},
            'method'  : 'POST',
            'body'    :
                {
                    "token"       : tokenEntity,
                    "businessName": name,
                    "name"        : name,
                    "city"        : 'city',
                    "address"     : 'address',
                    'zipCode'     : 'zipCode',
                    "tokenUser"   : getEnterpriseInfo().tokenUser,
                    "tokenCompany": getEnterpriseInfo().tokenCompany,
                }
        }
        if( company ) options.body.isCompany = 1
        options.body = JSON.stringify(options.body)
        const resp = await fetch(ENDPOINT+'/api/v1/pointOfSale/save', options);
        if( resp.status == 201 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        const json = await resp.json();
        console.log( json );
        return false;

    }catch(err){
        return false;
    }
}

export async function removeStore( tokenStore) {
    try{
        const resp = await fetch( ENDPOINT+'/api/v1/pointOfSale/remove?tokenCompany='+getEnterpriseInfo().tokenCompany+'&&tokenPointOfSale=' + tokenStore, { 'method':'DELETE' });
        if( resp.status == 200 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}

////////////////////////////MOVEMENTS////////////////////////////////////////////////
export async function getMovements( tokenUser, tokenCustomer,tokenSupplier, tokenPointOfSale, movementType, movementDateStart, movementDateEnd , skip, take,tokenPointOfSaleCompany ) {
    try{
        let dEnd = movementDateEnd.split("00:00:00.000Z").join("23:59:59.000Z");
        const options = {
            'headers' : { 'Content-Type' : 'application/json'},
            'method'  : 'POST',
            'body'    : JSON.stringify(
                {
                    "tokenUser"        : getEnterpriseInfo().role == 'operator' ?  getEnterpriseInfo().tokenUser : tokenUser,
                    "tokenCustomer"    : tokenCustomer,
                    "tokenSupplier"    : tokenSupplier,
                    "tokenPointOfSale" : tokenPointOfSale,
                    "tokenPointOfSaleCompany" : tokenPointOfSaleCompany,
                    "movementType"     : movementType,
                    "movementDateStart": movementDateStart, //"2025-04-20T13:01:56.055Z",
                    "movementDateEnd"  : dEnd    //"2025-04-20T13:01:56.055Z"
                  }
            )
        }
        const endpoint = ENDPOINT+'/api/v1/movement/list?tokenCompany='+getEnterpriseInfo().tokenCompany+`&skip=${skip}&take=${take}`;
        const resp = await fetch(endpoint, options);
        if( resp.status == 201 ){
            const json = await resp.json();
            if( json.success ){
                return json.data;
            }
        };
        return [];

    }catch(err){
        return [];
    }
}

export async function addMovementsFunction( title, movementDate, billNumber, amountTaxable, amount, movementType, metadata, tokenCustomer, tokenSupplier,docDate , tokenPointOfSale , tokenPointOfSaleCompany   ) {
    
    let causals = [];
    causals = await getCausal();
    const causal = causals.find( cc => cc.token == movementType );
    console.log( causal );
    //let totalTax = (amount - (amount / ((amountTaxable/100)+1))).toFixed(2);

    try{
        const options ={
            'headers' : { 'Content-Type' : 'application/json'},
            'method'  : 'POST',
            'body'    : JSON.stringify(
                {
                    "title"             : title ?? '',
                    "movementDate"      : movementDate,//"2025-04-20T13:10:07.698Z",
                    "billNumber"        : billNumber ?? '0',
                    "amountTaxable"     : amountTaxable,  //TOTALE IVA
                    "amount"            : amount,            //IMPONIBILE
                    "vatRate"           : 10,
                    "movementType"      : causal.movementType,
                    "metadata"          : JSON.stringify({nameCausal : causal.name}),
                    "tokenCustomer"     : tokenCustomer,
                    "tokenSupplier"     : tokenSupplier,
                    "tokenPointOfSale"  : tokenPointOfSale,
                    "tokenPointOfSaleCompany" :tokenPointOfSaleCompany,
                    "docDate"           : docDate,
                    "tokenUser"         : getEnterpriseInfo().tokenUser,
                    "tokenCompany"      : getEnterpriseInfo().tokenCompany,
                    "exported"          : 0
                }

            )
        }
        
        const resp = await fetch(ENDPOINT+'/api/v1/movement/save', options);
        if( resp.status == 201 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        const json = await resp.json();
        console.log( json );
        return false;

    }catch(err){
        return false;
    }
}

export async function removeMovements( tokenMovement ) {
    try{
        const resp = await fetch( ENDPOINT+'/api/v1/movement/remove?tokenCompany='+getEnterpriseInfo().tokenCompany+'&&tokenMovement=' + tokenMovement, { 'method':'DELETE' });
        if( resp.status == 200 ){
            const json = await resp.json();
            if( json.success ){
                return true;
            }
        };
        return false;

    }catch(err){
        return false;
    }
}

export async function csvExport ( rows, fileName ){
    try{
        let csv = '';
        rows.forEach((r) => {
            csv +=  r.movementDate +','+ r.operatorName+','+r.pointOfSale +','+(r.company ?? ' ' )+','+ r.causal+','+ r.movementType+','+ r.supplier+','+ r.amount+','+ r.amountTaxable +','+r.amountTotal +','+r.movementNumber+','+ r.docDate+','+ r.title +'\n';
        });

        let blob = new Blob([csv], { type:'text/csv'})
        let url = URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        URL.revokeObjectURL(url);
    }catch( err ){
        return false
    }
}